import React from "react";
import { State } from "../redux/offers";

import notFoundIcon from '../svg/404.svg';
import dashboardIcon from '../svg/dashboard-teal.svg';

import './NotFound.css';

class NotFound extends React.Component<State> {

  render() {

    return <div className="not_found">
      <div className="not_found__section not_found__section--to-right">
        <img className="not_found__icon" src={notFoundIcon} />
      </div>
      <div className="not_found__section not_found__section--to-left">
        <h3>Page Not Found.</h3>
        <span className="not_found__section-text">Sorry, we can’t find what you’re looking for.<br />Either this page doesn’t exist or it’s moved.</span>
        <div className="not_found__button-container">
          <a href="/" className="not_found__button">
            <img src={dashboardIcon} />
            <span>Back to Dashboard</span>
          </a>
        </div>
      </div>
    </div>
  }
}

export default NotFound;
